import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C5DataUploadTable } from "./table";
import { C5DataUploadEdit } from "./edit";

export default function C5DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C5DataUploadEdit />} />
      <Route index element={<C5DataUploadTable />} />
    </Routes>
  );
}
